import { ReactNode } from 'react';
import { LinkButton } from '../navigation';
import FieldWrapper, { FieldWrapperProps } from './FieldWrapper';
import classes from './HintBox.module.scss';

export default function HintBox({
  children,
  help,
  label,
  ...rest
}: HintBoxProps) {
  const fieldLabel = (help?.label as any) || label;
  return (
    <FieldWrapper label={fieldLabel} {...rest}>
      <div className={classes.children}>
        {help?.text && <p>{help.text}</p>}
        {children}
        {help?.url && (
          <LinkButton href={help.url} type="context">
            Learn more
          </LinkButton>
        )}
        {help?.action}
      </div>
    </FieldWrapper>
  );
}

export interface HintBoxProps extends FieldWrapperProps {
  help?: HelpItem;
}

export interface HelpItem {
  action?: ReactNode;
  label?: ReactNode;
  text?: ReactNode;
  url?: string;
}
